'use strict'

const toastrSettings = () => {
	/**
	 * Toastr Global Settings
	 * Options: error | info | success | warning
	 */
	toastr.options = {
		closeButton: true,
		progressBar: false,
		preventDuplicates: true,
		closeHtml: '<button><i class:"icon-off"></i></button>',
		// closeMethod : '',
		closeDuration: 300,
		closeEasing: 'swing',
		newestOnTop: false,
		showEasing: 'swing',
		hideEasing: 'linear',
		showMethod: 'slideDown',
		hideMethod: 'slideUp',
	}
}

export { toastrSettings }
